import React, {Component, Fragment} from 'react';

export default class GallerySection extends Component {

    getList() {
        const data = this.props.slides;
        return Object.keys(data).map(function (key) {
            const url = data[key];
            return (
                <a href={url} className="portfolio-item lightbox-link" data-background={url} key={key} style={{"cursor":"zoom-in"}}/>
            );
        });
    }

    render() {
        return (
            <Fragment>
                <h5 className="pt-5">Galeria</h5>
                <div className="mt-1 mb-5 grid lightbox" data-columns="3" data-gutter="2" data-cell-ratio="4/6">
                    {this.getList()}
                </div>
            </Fragment>
        );
    }

}


// WEBPACK FOOTER //
// ./src/visitors/components/post/sections/GallerySection.js